/**
 * Focus Shop - Custom Scripts
 */

document.addEventListener('DOMContentLoaded', function () {
  console.log('Focus Shop Theme Loaded');

  const cartDrawer = document.getElementById('CartDrawer');
  const cartOverlay = document.getElementById('CartDrawerOverlay');
  const closeCartBtn = document.getElementById('CloseCartDrawer');
  const cartNotification = document.getElementById('CartAddedNotification');
  const cartItemsContainer = document.getElementById('CartDrawerItems');

  // Toggle Cart Drawer
  function openCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('open');
    cartOverlay.classList.add('visible');
    document.body.classList.add('cart-open');
  }

  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('open');
    cartOverlay.classList.remove('visible');
    document.body.classList.remove('cart-open');
  }

  if (closeCartBtn) closeCartBtn.addEventListener('click', closeCartDrawer);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCartDrawer);

  // Global Cart Open Hook
  window.openCartDrawer = openCartDrawer;

  // Handle Cart Icon Click (in header)
  document.addEventListener('click', function (e) {
    if (e.target.closest('a[href="/cart"]')) {
      e.preventDefault();
      openCartDrawer();
    }
  });

  // Handle Product Form Submissions
  document.addEventListener('submit', function (e) {
    const form = e.target.closest('form[action="/cart/add"]');
    if (!form) return;

    e.preventDefault();
    const submitBtn = e.submitter;
    const isBuyNow = submitBtn && submitBtn.getAttribute('name') === 'checkout';

    if (submitBtn) submitBtn.disabled = true;

    const formData = new FormData(form);

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    })
      .then(response => response.json())
      .then(data => {
        updateCartDrawer();

        if (cartNotification) {
          cartNotification.classList.remove('translate-x-[150%]');
          setTimeout(() => cartNotification.classList.add('translate-x-[150%]'), 3000);
        }

        openCartDrawer();

        // If Buy Now was clicked, redirect to checkout after a short delay to let them see the drawer
        if (isBuyNow) {
          setTimeout(() => {
            window.location.href = '/checkout';
          }, 1000);
        }
      })
      .catch(error => console.error('Add to cart error:', error))
      .finally(() => {
        if (submitBtn && !isBuyNow) submitBtn.disabled = false;
      });
  });

  // Update Cart Drawer Function
  async function updateCartDrawer() {
    const itemsContainer = document.getElementById('CartDrawerItems');
    if (itemsContainer) itemsContainer.style.opacity = '0.5';

    // Save current phone number value before update
    const phoneInput = document.getElementById('cart-phone');
    const currentPhoneValue = phoneInput ? phoneInput.value : '';

    try {
      const response = await fetch('/cart?view=drawer');
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const newItems = doc.getElementById('CartDrawerItems');
      const newTotal = doc.getElementById('CartDrawerTotal');
      const newCountValue = doc.getElementById('CartDrawerCount');

      if (newItems && itemsContainer) itemsContainer.innerHTML = newItems.innerHTML;
      if (newTotal) {
        const totalEl = document.getElementById('CartDrawerTotal');
        if (totalEl) totalEl.innerHTML = newTotal.innerHTML;
      }

      // Restore phone number value after update
      const updatedPhoneInput = document.getElementById('cart-phone');
      if (updatedPhoneInput && currentPhoneValue) {
        updatedPhoneInput.value = currentPhoneValue;
      }

      // Update header count
      const count = newCountValue ? parseInt(newCountValue.innerText) : 0;
      const counts = document.querySelectorAll('.cart-count');
      counts.forEach(el => {
        el.innerText = count;
        el.style.display = count > 0 ? 'flex' : 'none';
      });

    } catch (err) {
      console.error('Update cart drawer error:', err);
    } finally {
      if (itemsContainer) itemsContainer.style.opacity = '1';
    }
  }

  // Make updateCartDrawer globally accessible
  window.updateCartDrawer = updateCartDrawer;

  // Global Function for Quantity Updates
  window.updateCartItem = function (key, quantity) {
    if (cartItemsContainer) cartItemsContainer.style.opacity = '0.5';

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: parseInt(quantity) })
    })
      .then(res => res.json())
      .then(() => updateCartDrawer())
      .catch(err => {
        console.error('Update item error:', err);
        if (cartItemsContainer) cartItemsContainer.style.opacity = '1';
      });
  };

  // Kit Details - clicking one opens/closes ALL on the page
  document.body.addEventListener('click', function(e) {
    const clickedSummary = e.target.closest('.kit-details summary');
    if (!clickedSummary) return;

    const clickedDetails = clickedSummary.closest('.kit-details');
    if (!clickedDetails) return;

    // Check current state of clicked element
    const isCurrentlyOpen = clickedDetails.hasAttribute('open');

    // Get all kit-details elements on the page
    const allKitDetails = document.querySelectorAll('.kit-details');

    // Toggle all to the same state
    allKitDetails.forEach(function(details) {
      if (isCurrentlyOpen) {
        details.removeAttribute('open');
      } else {
        details.setAttribute('open', '');
      }
    });

    // Prevent default to avoid double-toggling
    e.preventDefault();
    e.stopPropagation();
  }, true);

  // Auto-save phone number to cart attributes
  const phoneInput = document.getElementById('cart-phone');
  if (phoneInput) {
    let phoneUpdateTimeout;
    phoneInput.addEventListener('input', function() {
      clearTimeout(phoneUpdateTimeout);
      phoneUpdateTimeout = setTimeout(() => {
        const phoneValue = phoneInput.value.trim();
        if (phoneValue) {
          // Update cart attributes via AJAX
          fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              attributes: { 'Phone': phoneValue }
            })
          }).catch(err => console.error('Phone update error:', err));
        }
      }, 800); // Debounce for 800ms
    });
  }

  // Phone Number Validation for Checkout
  const cartForm = document.getElementById('CartDrawerForm');
  if (cartForm) {
    cartForm.addEventListener('submit', function(e) {
      const phoneInput = document.getElementById('cart-phone');
      if (!phoneInput) return;

      const phoneValue = phoneInput.value.trim();

      if (!phoneValue) {
        e.preventDefault();
        phoneInput.focus();
        phoneInput.classList.add('border-red-500', 'ring-2', 'ring-red-500');

        // Show error message
        let errorMsg = phoneInput.parentElement.querySelector('.phone-error-msg');
        if (!errorMsg) {
          errorMsg = document.createElement('p');
          errorMsg.className = 'phone-error-msg text-xs text-red-600 mt-1 font-semibold';
          errorMsg.textContent = 'Phone number is required to proceed with checkout';
          phoneInput.parentElement.appendChild(errorMsg);
        }

        // Remove error styling when user starts typing
        phoneInput.addEventListener('input', function() {
          phoneInput.classList.remove('border-red-500', 'ring-2', 'ring-red-500');
          const error = phoneInput.parentElement.querySelector('.phone-error-msg');
          if (error) error.remove();
        }, { once: true });

        return false;
      }

      // Validate phone number format (at least 10 digits)
      const phoneDigits = phoneValue.replace(/\D/g, '');
      if (phoneDigits.length < 10) {
        e.preventDefault();
        phoneInput.focus();
        phoneInput.classList.add('border-red-500', 'ring-2', 'ring-red-500');

        let errorMsg = phoneInput.parentElement.querySelector('.phone-error-msg');
        if (!errorMsg) {
          errorMsg = document.createElement('p');
          errorMsg.className = 'phone-error-msg text-xs text-red-600 mt-1 font-semibold';
          errorMsg.textContent = 'Please enter a valid phone number (at least 10 digits)';
          phoneInput.parentElement.appendChild(errorMsg);
        } else {
          errorMsg.textContent = 'Please enter a valid phone number (at least 10 digits)';
        }

        phoneInput.addEventListener('input', function() {
          phoneInput.classList.remove('border-red-500', 'ring-2', 'ring-red-500');
          const error = phoneInput.parentElement.querySelector('.phone-error-msg');
          if (error) error.remove();
        }, { once: true });

        return false;
      }
    });
  }
});
